module.exports = __webpack_public_path__ + "static/media/logo.ea0982b4.jpg";